import {
  ACTIONS_FOR_SUPPORT_NAMES,
  LEGAL_FRAMEWORK_AND_RISKS_NAMES,
  LIST_OF_RISKS_NAMES,
} from 'components/BusinessToolForm/Sections/LegalFrameworkAndRisks/utils/form';

const ACTIONS_INSTRUCTIONS = {
  [ACTIONS_FOR_SUPPORT_NAMES.ACTION]: {
    name: 'Verfahrensschritt',
    instruction:
      'Listen Sie alle obligatorischen rechtlichen Verfahren auf, die für die Tätigkeit des Unternehmens relevant sind. Identifizieren Sie zentrale rechtliche Prozesse, Einreichungen oder Schritte, die für die Erfüllung regulatorischer Anforderungen wesentlich sind.',
    exampleOne: 'Erlangung der USDA-Zertifizierung für die Sicherheit landwirtschaftlicher Geräte',
    exampleTwo: 'Marke eintragen lassen',
  },
  [ACTIONS_FOR_SUPPORT_NAMES.START_DATE]: {
    name: 'Fristen',
    instruction:
      'Geben Sie für jedes Verfahren den aktuellen Status sowie den erwarteten Zeitraum bis zum Abschluss an.',
    exampleOne: 'Mai 2024',
    exampleTwo: '',
  },
  [ACTIONS_FOR_SUPPORT_NAMES.EXPECTED_DEADLINE]: {
    name: 'Fristen',
    instruction:
      'Geben Sie für jedes Verfahren den aktuellen Status sowie den erwarteten Zeitraum bis zum Abschluss an.',
    exampleOne: 'abgeschlossen',
    exampleTwo: 'August 2024',
  },
};

const RISKS_INSTRUCTIONS = {
  [LIST_OF_RISKS_NAMES.NAME]: {
    name: 'Bezeichnung des Risikos',
    instruction:
      'Identifizieren Sie das Risiko und benennen Sie es eindeutig. Stellen Sie sicher, dass es spezifisch und kontextbezogen ist und verwenden Sie eine Terminologie, die die Art des Risikos präzise beschreibt.',
    exampleOne: 'Schwankende Rohstoffpreise',
    exampleTwo: 'Schwankende Wechselkurse',
  },
  [LIST_OF_RISKS_NAMES.GROUP]: {
    name: 'Risikogruppe',
    instruction:
      'Geben Sie die Risikogruppe prägnant an, z. B. wirtschaftliche Risiken, organisatorische Risiken, Marktrisiken, Produktions- und technische Risiken, rechtliche Risiken oder sonstige Risiken.',
    exampleOne: 'Finanzielle Risiken',
    exampleTwo: 'Operationelle Risiken',
  },
  [LIST_OF_RISKS_NAMES.NEGATIVE_IMPACT]: {
    name: 'Negative Auswirkungen',
    instruction:
      'Stellen Sie die negativen Auswirkungen der Risiken dar und heben Sie potenzielle Verluste, Störungen sowie Reputations- oder Betriebsschäden hervor.',
    exampleOne:
      'Unsichere Nachfrage nach landwirtschaftlichen Maschinen kann sich durch schwankende Rohstoffpreise auf Umsatz und Rentabilität von Agrotech auswirken. Preissteigerungen können Landwirte von Investitionen abhalten, während Preisrückgänge die Margen und das Verkaufsvolumen des Unternehmens beeinträchtigen können.',
    exampleTwo:
      'Schwankungen der Wechselkurse beeinflussen die Importkosten für Rohstoffe und die Exporterlöse des Unternehmens. Ungünstige Kurse erhöhen die Produktionskosten und verringern die Rentabilität, während günstige Kurse die Wettbewerbsfähigkeit verbessern, aber auch Auswirkungen auf die Preisstrategien haben können.',
  },
  [LIST_OF_RISKS_NAMES.PREVENTION_MEASURES]: {
    name: 'Vorbeugungsmaßnahmen',
    instruction:
      'Beginnen Sie mit einem Überblick über die spezifischen Maßnahmen, die Ihr Projekt zur Minderung identifizierter Risiken umgesetzt hat. Geben Sie detaillierte Einblicke in proaktive Schritte zur Risikobewältigung, wie z. B. Diversifizierung der Risiken, Nutzung von Versicherungslösungen, Aufbau von Rücklagen oder Bildung strategischer Partnerschaften.',
    exampleOne:
      'Das Unternehmen kann sein Produktportfolio diversifizieren, in Forschung für kosteneffiziente Produktion investieren, langfristige Verträge mit Lieferanten abschließen und flexible Preisstrategien implementieren.',
    exampleTwo:
      'Das Unternehmen kann sich mit Finanzinstrumenten absichern, seine Kundenbasis über verschiedene Regionen diversifizieren, die Produktion lokalisieren, um die Abhängigkeit von Importen zu verringern, und langfristige Verträge in stabilen Währungen verhandeln.',
  },
};

export const LEGAL_FRAMEWORKS_AND_RISKS_SECTION_INSTRUCTIONS = {
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.GENERAL_LAWS]: {
    name: 'Allgemeine Gesetze und Vorschriften',
    instruction:
      'Identifizieren Sie die Jurisdiktion, in der Ihr Unternehmen tätig ist, und listen Sie die Gesetze und Vorschriften auf, denen es unterliegt. Die Liste kann Gesellschaftsrecht, Arbeitsrecht und Steuerrecht umfassen. Stellen Sie die Einhaltung sicher, indem Sie relevante Gesetze und Verordnungen benennen und so einen rechtmäßigen Geschäftsbetrieb in der jeweiligen Jurisdiktion gewährleisten.',
    exampleOne:
      'Das Unternehmen ist in den Vereinigten Staaten tätig und unterliegt verschiedenen Gesetzen und Vorschriften, darunter dem Internal Revenue Code für die steuerliche Compliance, dem Fair Labor Standards Act für arbeitsrechtliche Regelungen und dem Securities Act von 1933 für Corporate Governance.',
    exampleTwo:
      'Das Unternehmen ist in der Jurisdiktion Kalifornien, USA, tätig. Der California Corporations Code, der California Labor Code und der California Revenue and Taxation Code regeln das Unternehmen. Die Einhaltung dieser Regelungen gewährleistet einen rechtmäßigen Geschäftsbetrieb in der betreffenden Jurisdiktion.',
  },
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.INDUSTRY_REQUIREMENTS]: {
    name: 'Branchenspezifische Anforderungen',
    instruction:
      'Beschreiben Sie die branchenspezifischen Gesetze, die Ihr Unternehmen einhalten muss. Geben Sie erforderliche Lizenzen, Zertifizierungen oder Genehmigungen an, die für die Compliance notwendig sind. Achten Sie auf Klarheit und Genauigkeit bei der Darstellung dieser Anforderungen.',
    exampleOne:
      'Das Unternehmen erfüllt branchenspezifische Vorschriften wie den Agricultural Improvement Act of 2018 (Farm Bill) für agrarwirtschaftliche Regelungen. Zusätzlich verfügt das Unternehmen über Zertifizierungen wie ISO 9001, ein Emissionskonformitätszertifikat sowie die USDA-Zertifizierung für die Sicherheit landwirtschaftlicher Geräte.',
    exampleTwo:
      'Das Unternehmen muss branchenspezifische Gesetze wie den Translation and Interpreting Services Act in der Sprachdienstleistungsbranche einhalten. Die Compliance erfordert den Erwerb von Lizenzen von der American Translators Association und der International Association of Professional Translators and Interpreters.',
  },
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LEGAL_REQUIREMENTS]: {
    name: 'Einhaltung rechtlicher Anforderungen',
    instruction:
      'Überprüfen Sie den Stand der Compliance des Unternehmens in Bezug auf die rechtlichen Anforderungen für die Geschäftstätigkeit. Identifizieren Sie Lücken oder Defizite und schlagen Sie einen Korrekturplan vor, um die vollständige Einhaltung der regulatorischen Standards zu gewährleisten.',
    exampleOne:
      'Das Unternehmen erfüllt derzeit die rechtlichen Anforderungen. Zur Schließung von Lücken strebt das Unternehmen die USDA-Zertifizierung für die Sicherheit landwirtschaftlicher Geräte an; die erforderlichen Unterlagen wurden bereits bei der US-Zertifizierungsbehörde eingereicht.',
    exampleTwo:
      'Das Unternehmen erfüllt alle rechtlichen Anforderungen für die Geschäftstätigkeit, einschließlich der Vorschriften für Sprachdienste, Lizenzen, Zertifizierungen und Genehmigungen in den relevanten Jurisdiktionen.',
  },
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LIST_OF_ACTIONS]: ACTIONS_INSTRUCTIONS,
  [LEGAL_FRAMEWORK_AND_RISKS_NAMES.LIST_OF_RISKS]: RISKS_INSTRUCTIONS,
};
